import React from "react";
import { Card, Button } from "react-bootstrap";

const countries = [
  {
    name: "USA",
    deals: 350,
    value: 1065,
    img: "/assets/img/payment-gateway/country-01.svg",
    color: "green",
  },
  {
    name: "UAE",
    deals: 221,
    value: 966,
    img: "/assets/img/payment-gateway/country-02.svg",
    color: "green",
  },
  {
    name: "Singapore",
    deals: 236,
    value: 959,
    img: "/assets/img/payment-gateway/country-03.svg",
    color: "red",
  },
  {
    name: "France",
    deals: 589,
    value: 879,
    img: "/assets/img/payment-gateway/country-04.svg",
    color: "green",
  },
  {
    name: "Norway",
    deals: 221,
    value: 632,
    img: "/assets/img/payment-gateway/country-05.svg",
    color: "red",
  },
];

// 🔥 MINI GRAPH COMPONENT
const MiniChart = ({ type }) => {
  const stroke = type === "green" ? "#22c55e" : "#ef4444";
  const fill = type === "green" ? "#22c55e33" : "#ef444433";

  return (
    <svg width="90" height="40">
      <polyline
        fill="none"
        stroke={stroke}
        strokeWidth="2"
        points="0,30 15,10 30,30 45,15 60,25 75,10 90,25"
      />
      <polygon
        fill={fill}
        points="0,30 15,10 30,30 45,15 60,25 75,10 90,25 90,40 0,40"
      />
    </svg>
  );
};

export default function DealsByCountry() {
  return (
    <Card className="dbc-card w-100">
      <Card.Header className="d-flex card-header-custom justify-content-between align-items-center">
        <h5 className="mb-0 fw-semibold">Deals By Country</h5>
        <Button className=" dbc-btn text-dark">View All</Button>
      </Card.Header>

      <Card.Body className="dbc-body">
        {countries.map((c, i) => (
          <div key={i} className="dbc-row">
            {/* LEFT */}
            <div className="d-flex align-items-center">
              <img src={c.img} className="dbc-flag" />
              <div className="ms-2">
                <h6 className="mb-1 fw-medium">{c.name}</h6>
                <span className="dbc-deals">Deals : {c.deals}</span>
              </div>
            </div>

            {/* MIDDLE GRAPH */}
            <div className="dbc-chart">
              <MiniChart type={c.color} />
            </div>

            {/* RIGHT */}
            <div className="text-end">
              <p className="dbc-label">Total Value</p>
              <h6 className="fw-medium">${c.value}.00</h6>
            </div>
          </div>
        ))}
      </Card.Body>

      {/* ✅ INLINE CSS */}
      <style>{`
        .dbc-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }


      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
        .dbc-btn {
                   background: #f9fafb;
          border: 1px solid #e5e7eb;
          font-size: 14px;
        }

        .dbc-btn:hover{
              
          border-color: #f97316 !important;
          color: #f97316 !important;
           background: #f9fafb;
          border: 1px solid #e5e7eb;
        
        }
        .dbc-body {
          padding-top: 10px;
        }

        .dbc-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 18px;
        }

        .dbc-flag {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px solid #eee;
        }

        .dbc-deals {
          font-size: 13px;
          color: #6b7280;
        }

        .dbc-chart {
          flex: 1;
          text-align: center;
        }

        .dbc-label {
          font-size: 13px;
          color: #9ca3af;
          margin-bottom: 2px;
        }

           .custom-toggle:hover {
          background: #fff !important;
          border-color: #f97316 !important;
          color: #f97316 !important;
           background: #f9fafb;
          border: 1px solid #e5e7eb;
          font-size: 14px;
        }
        h6 {
          margin: 0;
        }
      `}</style>
    </Card>
  );
}